var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64425 6.60059H6.75627C7.37588 6.60059 7.72292 7.26364 7.34013 7.71606L4.78415 10.7369C4.48682 11.0883 3.91373 11.0883 3.61646 10.7369L1.06042 7.71606C0.677658 7.26364 1.02471 6.60059 1.64425 6.60059Z",
    fill: "#132441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75627 4.39986H1.64425C1.02471 4.39986 0.677658 3.73679 1.06042 3.2844L3.61646 0.263505C3.91373 -0.0878349 4.48682 -0.0878349 4.78415 0.263505L7.34013 3.2844C7.72292 3.73679 7.37588 4.39986 6.75627 4.39986Z",
    fill: "#132441"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDefault);
export default __webpack_public_path__ + "static/media/SortDefault.a364a63dc2607fd4ab8912d89ac41f3c.svg";
export { ForwardRef as ReactComponent };